export default "__VITE_ASSET__B6UFaODz__"